import { Component } from "react"
import PropTypes from "prop-types"
import { includes, get } from "lodash"
import { Card, Button } from "@mui/material"
import Optimization from "modules/optimization"
import Rebalance from "modules/rebalance"
import SaveExperiment from "modules/save-experiment"
import LoadingWrapper from "components/loading-wrapper"
import ExperimentLoading from "./components/experiment-loading"
import ExperimentError from "./components/experiment-error"
import withNavigate from "hocs/withNavigate"
import "./style.scss"

const EDIT_EXPERIMENT = ["OPTIMIZATION", "SIMULATION"]
class EditExperiment extends Component {
  static propTypes = {
    experiment: PropTypes.object.isRequired,
    optimizeTradesConstraints: PropTypes.object,
    experimentsUrl: PropTypes.string.isRequired,
    navigate: PropTypes.func.isRequired,
    experimentToSave: PropTypes.object,
    openDialog: PropTypes.func.isRequired,
    loadRebalanceConfig: PropTypes.func.isRequired,
    hasChanges: PropTypes.bool.isRequired,
    saveEnabled: PropTypes.bool.isRequired,
    isOneDayExperiment: PropTypes.bool.isRequired,
    index: PropTypes.number,
    rebalanceConfig: PropTypes.object,
    status: PropTypes.string.isRequired,
    portfolioUUID: PropTypes.string.isRequired,
    portfolioAlias: PropTypes.string.isRequired,
  }

  componentDidMount() {
    const { navigate, experiment, loadRebalanceConfig, experimentsUrl, rebalanceConfig } = this.props
    if (experiment) {
      if (!includes(EDIT_EXPERIMENT, experiment.type)) {
        setTimeout(() => navigate(experimentsUrl, { replace: true }))
      } else if (experiment.type === "SIMULATION") {
        loadRebalanceConfig(rebalanceConfig)
      }
    }
  }

  confirmClose = () => {
    const { experimentsUrl, navigate } = this.props
    navigate(experimentsUrl)
  }

  onClose = () => {
    const { experimentsUrl, navigate, experiment, openDialog, hasChanges } = this.props
    if (hasChanges) {
      openDialog({
        title: "Cancel Modifications",
        contentText: `Any edits made to ${experiment.name} will be lost. Are you sure you want to continue?`,
        buttons: [{
          text: "Confirm",
          type: "primary",
          action: () => this.confirmClose(),
        }],
      })
    } else {
      navigate(experimentsUrl)
    }
  }

  toggleSaveExperiment = (newExperiment = false) => {
    const { openDialog, experiment, experimentToSave, index, isOneDayExperiment, portfolioUUID, portfolioAlias } = this.props
    const selectedExperiment = { ...experimentToSave, name: !newExperiment ? experiment.name : "", id: experiment.id }

    openDialog({
      title: newExperiment ? "Save Experiment" : `Update Experiment: ${experiment.name}`,
      content: <SaveExperiment experiment={selectedExperiment} isOneDayExperiment={isOneDayExperiment} index={index} isAdvanceEditMode={!newExperiment} portfolioAlias={portfolioAlias} portfolioId={portfolioUUID} />,
    })
  }

  render() {
    const { experiment, saveEnabled, status } = this.props
    if (!includes(EDIT_EXPERIMENT, experiment.type)) {
      return null
    }

    let subComponent
    switch (get(experiment, "type")) {
      case "OPTIMIZATION":
        subComponent = <Optimization />
        break
      case "SIMULATION":
        subComponent = <Rebalance />
        break
    }

    const loadingComponent = <ExperimentLoading />
    const errorComponent = <ExperimentError text="There was an error while loading the experiment. Please try again." />

    return <div className="modules_edit-experiment">
      <Card className="edit-experiment-card">
        <div className="edit-label">{`Update Experiment: ${experiment.name} `}</div>
        <div className="buttons-wrapper">
          <Button color="primary" variant="contained" onClick={() => this.toggleSaveExperiment(false)} disabled={!saveEnabled}>Update And Close</Button>
          <Button color="primary" variant="contained" onClick={() => this.toggleSaveExperiment(true)}>Save As New</Button>
          <Button color="secondary" variant="contained" onClick={this.onClose} className="cancel-button">Cancel</Button>
        </div>
      </Card>

      <LoadingWrapper status={[status]} loadingComponent={loadingComponent} errorComponent={errorComponent}>
        {subComponent}
      </LoadingWrapper>
    </div>
  }
}

export default withNavigate(EditExperiment)
